/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as GestorRequisitosRouteRouteImport } from './routes/gestor-requisitos/route'
import { Route as GestorEvaluacionRouteRouteImport } from './routes/gestor-evaluacion/route'
import { Route as GestorCitasRouteRouteImport } from './routes/gestor-citas/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RetryIndexRouteImport } from './routes/retry/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'

const RolesIndexLazyRouteImport = createFileRoute('/roles/')()
const GestorEvaluacionIndexLazyRouteImport = createFileRoute(
  '/gestor-evaluacion/',
)()
const GestorRequisitosSolicitudesIndexLazyRouteImport = createFileRoute(
  '/gestor-requisitos/solicitudes/',
)()
const GestorRequisitosDetalleIndexLazyRouteImport = createFileRoute(
  '/gestor-requisitos/detalle/',
)()
const GestorEvaluacionSolicitudesIndexLazyRouteImport = createFileRoute(
  '/gestor-evaluacion/solicitudes/',
)()
const GestorEvaluacionDetalleIndexLazyRouteImport = createFileRoute(
  '/gestor-evaluacion/detalle/',
)()
const GestorCitasSolicitudesIndexLazyRouteImport = createFileRoute(
  '/gestor-citas/solicitudes/',
)()
const GestorCitasDetalleIndexLazyRouteImport = createFileRoute(
  '/gestor-citas/detalle/',
)()

const GestorRequisitosRouteRoute = GestorRequisitosRouteRouteImport.update({
  id: '/gestor-requisitos',
  path: '/gestor-requisitos',
  getParentRoute: () => rootRouteImport,
} as any)
const GestorEvaluacionRouteRoute = GestorEvaluacionRouteRouteImport.update({
  id: '/gestor-evaluacion',
  path: '/gestor-evaluacion',
  getParentRoute: () => rootRouteImport,
} as any)
const GestorCitasRouteRoute = GestorCitasRouteRouteImport.update({
  id: '/gestor-citas',
  path: '/gestor-citas',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesIndexLazyRoute = RolesIndexLazyRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/roles/index.lazy').then((d) => d.Route))
const GestorEvaluacionIndexLazyRoute =
  GestorEvaluacionIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GestorEvaluacionRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-evaluacion/index.lazy').then((d) => d.Route),
  )
const RetryIndexRoute = RetryIndexRouteImport.update({
  id: '/retry/',
  path: '/retry/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const GestorRequisitosSolicitudesIndexLazyRoute =
  GestorRequisitosSolicitudesIndexLazyRouteImport.update({
    id: '/solicitudes/',
    path: '/solicitudes/',
    getParentRoute: () => GestorRequisitosRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-requisitos/solicitudes/index.lazy').then(
      (d) => d.Route,
    ),
  )
const GestorRequisitosDetalleIndexLazyRoute =
  GestorRequisitosDetalleIndexLazyRouteImport.update({
    id: '/detalle/',
    path: '/detalle/',
    getParentRoute: () => GestorRequisitosRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-requisitos/detalle/index.lazy').then(
      (d) => d.Route,
    ),
  )
const GestorEvaluacionSolicitudesIndexLazyRoute =
  GestorEvaluacionSolicitudesIndexLazyRouteImport.update({
    id: '/solicitudes/',
    path: '/solicitudes/',
    getParentRoute: () => GestorEvaluacionRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-evaluacion/solicitudes/index.lazy').then(
      (d) => d.Route,
    ),
  )
const GestorEvaluacionDetalleIndexLazyRoute =
  GestorEvaluacionDetalleIndexLazyRouteImport.update({
    id: '/detalle/',
    path: '/detalle/',
    getParentRoute: () => GestorEvaluacionRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-evaluacion/detalle/index.lazy').then(
      (d) => d.Route,
    ),
  )
const GestorCitasSolicitudesIndexLazyRoute =
  GestorCitasSolicitudesIndexLazyRouteImport.update({
    id: '/solicitudes/',
    path: '/solicitudes/',
    getParentRoute: () => GestorCitasRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-citas/solicitudes/index.lazy').then((d) => d.Route),
  )
const GestorCitasDetalleIndexLazyRoute =
  GestorCitasDetalleIndexLazyRouteImport.update({
    id: '/detalle/',
    path: '/detalle/',
    getParentRoute: () => GestorCitasRouteRoute,
  } as any).lazy(() =>
    import('./routes/gestor-citas/detalle/index.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/gestor-citas': typeof GestorCitasRouteRouteWithChildren
  '/gestor-evaluacion': typeof GestorEvaluacionRouteRouteWithChildren
  '/gestor-requisitos': typeof GestorRequisitosRouteRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/retry/': typeof RetryIndexRoute
  '/gestor-evaluacion/': typeof GestorEvaluacionIndexLazyRoute
  '/roles/': typeof RolesIndexLazyRoute
  '/gestor-citas/detalle/': typeof GestorCitasDetalleIndexLazyRoute
  '/gestor-citas/solicitudes/': typeof GestorCitasSolicitudesIndexLazyRoute
  '/gestor-evaluacion/detalle/': typeof GestorEvaluacionDetalleIndexLazyRoute
  '/gestor-evaluacion/solicitudes/': typeof GestorEvaluacionSolicitudesIndexLazyRoute
  '/gestor-requisitos/detalle/': typeof GestorRequisitosDetalleIndexLazyRoute
  '/gestor-requisitos/solicitudes/': typeof GestorRequisitosSolicitudesIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gestor-citas': typeof GestorCitasRouteRouteWithChildren
  '/gestor-requisitos': typeof GestorRequisitosRouteRouteWithChildren
  '/login': typeof LoginIndexRoute
  '/retry': typeof RetryIndexRoute
  '/gestor-evaluacion': typeof GestorEvaluacionIndexLazyRoute
  '/roles': typeof RolesIndexLazyRoute
  '/gestor-citas/detalle': typeof GestorCitasDetalleIndexLazyRoute
  '/gestor-citas/solicitudes': typeof GestorCitasSolicitudesIndexLazyRoute
  '/gestor-evaluacion/detalle': typeof GestorEvaluacionDetalleIndexLazyRoute
  '/gestor-evaluacion/solicitudes': typeof GestorEvaluacionSolicitudesIndexLazyRoute
  '/gestor-requisitos/detalle': typeof GestorRequisitosDetalleIndexLazyRoute
  '/gestor-requisitos/solicitudes': typeof GestorRequisitosSolicitudesIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/gestor-citas': typeof GestorCitasRouteRouteWithChildren
  '/gestor-evaluacion': typeof GestorEvaluacionRouteRouteWithChildren
  '/gestor-requisitos': typeof GestorRequisitosRouteRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/retry/': typeof RetryIndexRoute
  '/gestor-evaluacion/': typeof GestorEvaluacionIndexLazyRoute
  '/roles/': typeof RolesIndexLazyRoute
  '/gestor-citas/detalle/': typeof GestorCitasDetalleIndexLazyRoute
  '/gestor-citas/solicitudes/': typeof GestorCitasSolicitudesIndexLazyRoute
  '/gestor-evaluacion/detalle/': typeof GestorEvaluacionDetalleIndexLazyRoute
  '/gestor-evaluacion/solicitudes/': typeof GestorEvaluacionSolicitudesIndexLazyRoute
  '/gestor-requisitos/detalle/': typeof GestorRequisitosDetalleIndexLazyRoute
  '/gestor-requisitos/solicitudes/': typeof GestorRequisitosSolicitudesIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/gestor-citas'
    | '/gestor-evaluacion'
    | '/gestor-requisitos'
    | '/login/'
    | '/retry/'
    | '/gestor-evaluacion/'
    | '/roles/'
    | '/gestor-citas/detalle/'
    | '/gestor-citas/solicitudes/'
    | '/gestor-evaluacion/detalle/'
    | '/gestor-evaluacion/solicitudes/'
    | '/gestor-requisitos/detalle/'
    | '/gestor-requisitos/solicitudes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gestor-citas'
    | '/gestor-requisitos'
    | '/login'
    | '/retry'
    | '/gestor-evaluacion'
    | '/roles'
    | '/gestor-citas/detalle'
    | '/gestor-citas/solicitudes'
    | '/gestor-evaluacion/detalle'
    | '/gestor-evaluacion/solicitudes'
    | '/gestor-requisitos/detalle'
    | '/gestor-requisitos/solicitudes'
  id:
    | '__root__'
    | '/'
    | '/gestor-citas'
    | '/gestor-evaluacion'
    | '/gestor-requisitos'
    | '/login/'
    | '/retry/'
    | '/gestor-evaluacion/'
    | '/roles/'
    | '/gestor-citas/detalle/'
    | '/gestor-citas/solicitudes/'
    | '/gestor-evaluacion/detalle/'
    | '/gestor-evaluacion/solicitudes/'
    | '/gestor-requisitos/detalle/'
    | '/gestor-requisitos/solicitudes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GestorCitasRouteRoute: typeof GestorCitasRouteRouteWithChildren
  GestorEvaluacionRouteRoute: typeof GestorEvaluacionRouteRouteWithChildren
  GestorRequisitosRouteRoute: typeof GestorRequisitosRouteRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
  RetryIndexRoute: typeof RetryIndexRoute
  RolesIndexLazyRoute: typeof RolesIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/gestor-requisitos': {
      id: '/gestor-requisitos'
      path: '/gestor-requisitos'
      fullPath: '/gestor-requisitos'
      preLoaderRoute: typeof GestorRequisitosRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor-evaluacion': {
      id: '/gestor-evaluacion'
      path: '/gestor-evaluacion'
      fullPath: '/gestor-evaluacion'
      preLoaderRoute: typeof GestorEvaluacionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor-citas': {
      id: '/gestor-citas'
      path: '/gestor-citas'
      fullPath: '/gestor-citas'
      preLoaderRoute: typeof GestorCitasRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles/': {
      id: '/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof RolesIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor-evaluacion/': {
      id: '/gestor-evaluacion/'
      path: '/'
      fullPath: '/gestor-evaluacion/'
      preLoaderRoute: typeof GestorEvaluacionIndexLazyRouteImport
      parentRoute: typeof GestorEvaluacionRouteRoute
    }
    '/retry/': {
      id: '/retry/'
      path: '/retry'
      fullPath: '/retry/'
      preLoaderRoute: typeof RetryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor-requisitos/solicitudes/': {
      id: '/gestor-requisitos/solicitudes/'
      path: '/solicitudes'
      fullPath: '/gestor-requisitos/solicitudes/'
      preLoaderRoute: typeof GestorRequisitosSolicitudesIndexLazyRouteImport
      parentRoute: typeof GestorRequisitosRouteRoute
    }
    '/gestor-requisitos/detalle/': {
      id: '/gestor-requisitos/detalle/'
      path: '/detalle'
      fullPath: '/gestor-requisitos/detalle/'
      preLoaderRoute: typeof GestorRequisitosDetalleIndexLazyRouteImport
      parentRoute: typeof GestorRequisitosRouteRoute
    }
    '/gestor-evaluacion/solicitudes/': {
      id: '/gestor-evaluacion/solicitudes/'
      path: '/solicitudes'
      fullPath: '/gestor-evaluacion/solicitudes/'
      preLoaderRoute: typeof GestorEvaluacionSolicitudesIndexLazyRouteImport
      parentRoute: typeof GestorEvaluacionRouteRoute
    }
    '/gestor-evaluacion/detalle/': {
      id: '/gestor-evaluacion/detalle/'
      path: '/detalle'
      fullPath: '/gestor-evaluacion/detalle/'
      preLoaderRoute: typeof GestorEvaluacionDetalleIndexLazyRouteImport
      parentRoute: typeof GestorEvaluacionRouteRoute
    }
    '/gestor-citas/solicitudes/': {
      id: '/gestor-citas/solicitudes/'
      path: '/solicitudes'
      fullPath: '/gestor-citas/solicitudes/'
      preLoaderRoute: typeof GestorCitasSolicitudesIndexLazyRouteImport
      parentRoute: typeof GestorCitasRouteRoute
    }
    '/gestor-citas/detalle/': {
      id: '/gestor-citas/detalle/'
      path: '/detalle'
      fullPath: '/gestor-citas/detalle/'
      preLoaderRoute: typeof GestorCitasDetalleIndexLazyRouteImport
      parentRoute: typeof GestorCitasRouteRoute
    }
  }
}

interface GestorCitasRouteRouteChildren {
  GestorCitasDetalleIndexLazyRoute: typeof GestorCitasDetalleIndexLazyRoute
  GestorCitasSolicitudesIndexLazyRoute: typeof GestorCitasSolicitudesIndexLazyRoute
}

const GestorCitasRouteRouteChildren: GestorCitasRouteRouteChildren = {
  GestorCitasDetalleIndexLazyRoute: GestorCitasDetalleIndexLazyRoute,
  GestorCitasSolicitudesIndexLazyRoute: GestorCitasSolicitudesIndexLazyRoute,
}

const GestorCitasRouteRouteWithChildren =
  GestorCitasRouteRoute._addFileChildren(GestorCitasRouteRouteChildren)

interface GestorEvaluacionRouteRouteChildren {
  GestorEvaluacionIndexLazyRoute: typeof GestorEvaluacionIndexLazyRoute
  GestorEvaluacionDetalleIndexLazyRoute: typeof GestorEvaluacionDetalleIndexLazyRoute
  GestorEvaluacionSolicitudesIndexLazyRoute: typeof GestorEvaluacionSolicitudesIndexLazyRoute
}

const GestorEvaluacionRouteRouteChildren: GestorEvaluacionRouteRouteChildren = {
  GestorEvaluacionIndexLazyRoute: GestorEvaluacionIndexLazyRoute,
  GestorEvaluacionDetalleIndexLazyRoute: GestorEvaluacionDetalleIndexLazyRoute,
  GestorEvaluacionSolicitudesIndexLazyRoute:
    GestorEvaluacionSolicitudesIndexLazyRoute,
}

const GestorEvaluacionRouteRouteWithChildren =
  GestorEvaluacionRouteRoute._addFileChildren(
    GestorEvaluacionRouteRouteChildren,
  )

interface GestorRequisitosRouteRouteChildren {
  GestorRequisitosDetalleIndexLazyRoute: typeof GestorRequisitosDetalleIndexLazyRoute
  GestorRequisitosSolicitudesIndexLazyRoute: typeof GestorRequisitosSolicitudesIndexLazyRoute
}

const GestorRequisitosRouteRouteChildren: GestorRequisitosRouteRouteChildren = {
  GestorRequisitosDetalleIndexLazyRoute: GestorRequisitosDetalleIndexLazyRoute,
  GestorRequisitosSolicitudesIndexLazyRoute:
    GestorRequisitosSolicitudesIndexLazyRoute,
}

const GestorRequisitosRouteRouteWithChildren =
  GestorRequisitosRouteRoute._addFileChildren(
    GestorRequisitosRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GestorCitasRouteRoute: GestorCitasRouteRouteWithChildren,
  GestorEvaluacionRouteRoute: GestorEvaluacionRouteRouteWithChildren,
  GestorRequisitosRouteRoute: GestorRequisitosRouteRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
  RetryIndexRoute: RetryIndexRoute,
  RolesIndexLazyRoute: RolesIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
